import { LoadingState, } from './types.js';
export const createNotLoaded = () => ({
    loadingState: LoadingState.NotLoaded,
});
export const createLoading = () => ({
    loadingState: LoadingState.Loading,
});
export const createReloading = (data) => ({
    loadingState: LoadingState.Reloading,
    data,
});
export const createLoaded = (data) => ({
    loadingState: LoadingState.Loaded,
    data,
});
export const createError = (error) => ({
    loadingState: LoadingState.Error,
    error,
});
export const createPartialLoading = (data) => ({
    loadingState: LoadingState.LoadingPartial,
    data,
});
export const createPartialError = (data, error) => ({
    loadingState: LoadingState.ErrorPartial,
    error,
    data,
});
//# sourceMappingURL=utils.js.map